import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";

export const StyledEntityLink = styled(EntityLink)`
  font-size: 16px;
  font-family: ${fontRoboto};
`;
